import { useStore } from "ra-core";

export const VOICE_LANGUAGES = [
  { code: "en-US", label: "English" },
  { code: "da-DK", label: "Dansk" },
  { code: "sv-SE", label: "Svenska" },
  { code: "fi-FI", label: "Suomi" },
] as const;

export type VoiceLanguageCode = (typeof VOICE_LANGUAGES)[number]["code"];

export function useVoiceAgentLanguage() {
  return useStore<VoiceLanguageCode>("crm.voiceLanguage", "en-US");
}
